import CheckBoxItem, { CheckBoxItemProps } from './CheckBoxItem';

export type { CheckBoxItemProps };
export default CheckBoxItem;
